module.exports = __webpack_public_path__ + "static/media/mobile-nav-black.b01f832d.svg";